module.exports = "/_next/static/images/d90e129c832ce16c93568a297792c379-roxinho-scene-card-with-phone-lg@1x.jpg.webp";